/* ref_list.control_adapter.js */

"use strict";
const $ = require("jquery");
const _ = require("lodash");
const underscoreString = require("underscore.string");
_.mixin(underscoreString.exports());
const EventEmitter = require("events").EventEmitter;
const util = require("util");
const glueJay = require("@gluenetworks/gluejay").Gluejay;
const q = require("q");
const CheckBox = require("@gluenetworks/input_checkbox_control");
const StyleUtil = require("../StyleUtil");

/**
 * @event RefListControlAdapter#ValueChanged
 * @type {Object}
 * @property oldValue {string} The previous value
 * @property newValue {string} The new value
 */

/**
 * @class RefListControlAdapter
 * @classdesc renders the Select Options Jtype.
 * @implements AngularControlAdapter
 *
 * @param logger {Bunyan} The logger
 * @param containingElem {DomElement} The containing dom element for this control
 * @param formCtrlDef {FormControlDefinition} The definition of this control object.
 *
 * @requires util
 * @requires EventEmitter
 *
 * @fires RefListControlAdapter#ValueChanged
 */
module.exports = function RefListAdapter(logger, containingElem, formCtrlDef) {
    var self = this;
    var loadedDeferred = q.defer();
    var addedItemPromises = [];

    //call Event Emitter Constructor
    EventEmitter.call(this);
    this._multiEditMode = _.get(formCtrlDef, "displayModeOptions.multiEditMode", false);
    var _scope;
    var _oldValue;
    var _oldInvalidStatus = false;
    var _validationMessages = [];
    var _uiCheckboxItems = [];
    var _refOptionIdMap = {};
    var _itemsRegistry = {};
    var _defaultStringValue = "";
    var _showReorder = true;
    var _minDisplayLines = 0;
    var _showCheckAll = true;
    var _showUnCheckAll = true;
    var _required = false;
    if (_.has(formCtrlDef, "configSettings.Display.ref.showReOrder")) {
        _showReorder = _.get(formCtrlDef, "configSettings.Display.ref.showReOrder");
    }
    // Handle second spelling of showReorder
    if (_.has(formCtrlDef, "configSettings.Display.ref.showReorder")) {
        _showReorder = _.get(formCtrlDef, "configSettings.Display.ref.showReorder");
    }
    if (_.has(formCtrlDef, "configSettings.Display.ref.minLineCount")) {
        _minDisplayLines = _.get(formCtrlDef, "configSettings.Display.ref.minLineCount");
    }
    if (_.has(formCtrlDef, "configSettings.Display.ref.showCheckAll")) {
        _showCheckAll = _.get(formCtrlDef, "configSettings.Display.ref.showCheckAll");
    }
    if (_.has(formCtrlDef, "configSettings.Display.ref.showCheckAll")) {
        _showUnCheckAll = _.get(formCtrlDef, "configSettings.Display.ref.showCheckAll");
    }
    if (formCtrlDef.validationInfo && formCtrlDef.validationInfo.required) {
        _required = true;
    }

    //The name of the control
    this.name = formCtrlDef.name;
    this.templateName = "templatecache/templates/ref_list.template.html";
    this.arrayParentElem = {};

    function _valueChangedListener() {
        _fireValueChanged();
        self._updateValidityStatus();
    }
    /**
     * Fire the Value Changed Event
     * @private
     */
    function _fireValueChanged() {
        //Get the new Value
        var newVal = self.getValue();
        self.emit("ValueChanged", {
            name: formCtrlDef.name,
            containingElem: self.arrayParentElem,
            controlAdapter: self,
            formControlDefinition: formCtrlDef,
            oldValue: _oldValue,
            newValue: newVal,
        });
        _oldValue = newVal;
        _scope.setRefLaunchTitle();
    }

    function _fireInvalidStatusChanged() {
        let newInvalidStatus = self.isInvalid();
        if (newInvalidStatus !== _oldInvalidStatus) {
            self.emit("Invalid", {
                name: formCtrlDef.name,
                containingElem: self.containingElem,
                controlAdapter: self,
                formControlDefinition: formCtrlDef,
                oldValue: _oldInvalidStatus,
                newValue: newInvalidStatus,
            });
            _oldInvalidStatus = newInvalidStatus;
        }
    }

    this._updateValidityStatus = function () {
        let newInvalidStatus = self.isInvalid();
        let fieldSetElem = self.arrayParentElem.find(
            "> .array_nested_container > .ref-container"
        )[0];
        if (newInvalidStatus) {
            _validationMessages = ["This is a required field."];
            fieldSetElem.classList.add("ref-invalid");
            self._errorsDiv.textContent = _validationMessages[0];
            self._errorsDiv.style.display = "block";
        } else {
            _validationMessages = [];
            fieldSetElem.classList.remove("ref-invalid");
            self._errorsDiv.textContent = "";
            self._errorsDiv.style.display = "none";
        }
        _fireInvalidStatusChanged();
    };

    /**
     * Set the initial state of the readOnly.
     * @private
     */
    function _setInitialReadOnlyState() {
        if (self._readOnlyField) {
            self.setReadOnly(true);
        }
        if (self._multiEditMode) {
            self.setReadOnly(true);
        }
    }

    /********************************************************************************/
    /*** END Private API                                                          ***/
    /*** START Public API                                                         ***/
    /********************************************************************************/
    //The name of the control
    this.name = formCtrlDef.name;

    /**
     * @returns the data associated with this control.
     */
    this.getValue = function () {
        let val = {"@ref": {instances: []}};
        let instances = val["@ref"].instances;
        _uiCheckboxItems.forEach(function (item, index) {
            let checked = item.checkBox.getValue();
            if (checked) {
                instances.push(_refOptionIdMap[item.renderer.settings.instanceId]);
            }
        });
        return val;
    };

    /**
     * Set this controls current value.
     * @param value {string} The value to set this control to.
     * @returns the value associated with this control, it might not always be the same as the value passed in for
     * example adapters with a ValueScope.PARENT.
     */
    this.setValue = function (value) {
        this.tearDown();
        let refKeys = Object.keys(_refOptionIdMap);
        let clonedMap = _.clone(_refOptionIdMap);
        if (_.isArray(_.get(value, "@ref.instances"))) {
            let instances = _.get(value, "@ref.instances");
            refKeys = [];
            instances.forEach(function (instance) {
                refKeys.push(instance.instanceId);
                delete clonedMap[instance.instanceId];
            });
            let unUsedKeys = Object.keys(clonedMap);
            this.sortInstanceNames(unUsedKeys);
            refKeys.push(...unUsedKeys);
        }
        this.initializeCheckboxes(refKeys);
        if (value && value["@ref"]) {
            if (value["@ref"].instances && _.isArray(value["@ref"].instances)) {
                let instanceId = "";
                value["@ref"].instances.forEach(function (v) {
                    instanceId = v.instanceId;
                    _uiCheckboxItems.forEach(function (item) {
                        if (item.renderer.settings.instanceId === instanceId) {
                            item.checkBox.setValue(true);
                        }
                    });
                });
            }
        }
        return self.getValue();
    };

    this.sortInstanceNames = function (instanceKeys) {
        instanceKeys.sort((aKey, bKey) => {
            let aRef = _refOptionIdMap[aKey].instanceName;
            let bRef = _refOptionIdMap[bKey].instanceName;
            if (aRef > bRef) {
                return 1;
            } else if (aRef < bRef) {
                return -1;
            } else {
                return 0;
            }
        });
    };

    /**
     * Tear down this control
     */
    this.tearDown = function () {
        addedItemPromises = [];
        Object.keys(_itemsRegistry).forEach(function (itemId) {
            _scope.Array.closeItem(itemId, true);
        });
    };

    this.getMultiEditActive = function () {
        return this._multiEditActive;
    };

    this.setMultiEditActive = function (flag) {
        if (!this._readOnlyField) {
            this.setReadOnly(!flag);
            let oldValue = this._multiEditActive;
            this._multiEditActive = flag;
            this._updateValidityStatus();
            if (oldValue !== this._multiEditActive) {
                this.emit("MultiEditActive", {
                    oldValue: oldValue,
                    newValue: this._multiEditActive,
                });
            }
        }
    };

    this.setReadOnly = function (flag) {
        let arrayFooter = containingElem.find(".array_footer");
        let arrayActionItems = containingElem.find(".ref_item_actions");
        if (flag) {
            if (arrayFooter[0]) {
                arrayFooter[0].style.visibility = "hidden";
            }
            arrayActionItems.each((index) => {
                arrayActionItems[index].style.visibility = "hidden";
            });
            _uiCheckboxItems.forEach(function (item) {
                if (item.checkBox) {
                    item.checkBox.setDisabled(true);
                }
            });
        } else {
            if (arrayFooter[0]) {
                arrayFooter[0].removeAttribute("style");
            }
            arrayActionItems.each((index) => {
                arrayActionItems[index].removeAttribute("style");
            });
            _uiCheckboxItems.forEach(function (item) {
                if (item.checkBox) {
                    item.checkBox.setDisabled(false);
                }
            });
        }
    };

    this.isInvalid = function () {
        if (this._multiEditMode && !this.getMultiEditActive()) {
            return false;
        }
        return _required && _.isEmpty(this.getValue()["@ref"].instances) ? true : false;
    };

    this.getValidationMessages = function () {
        return _validationMessages.slice(0);
    };
    /********************************************************************************/
    /*** END Public API                                                           ***/
    /*** Start Angular/Render Work                                                ***/
    /********************************************************************************/

    /**
     * A Hook to start the angular work, due to timing issues don't try anything angularis before this hook is called.
     * @param $scope {$scope} Angular $scope
     * @param $templateCache {$templateCache}
     */
    this.$init = function ($scope, $templateCache, $compile, $timeout) {
        _scope = $scope;
        $scope.formCtrlDef = formCtrlDef;

        //Get the options
        glueJay.expandJtypeRefs(formCtrlDef.configSettings);

        $scope.setRefLaunchTitle = () => {
            "use strict";
            let val = this.getValue();
            let launchIcon = containingElem.find(".launch-ref");
            if (launchIcon.length) {
                let setTooltip = (nameArray, nameType) => {
                    if (_.get($scope, "refInfo.construct")) {
                        if (nameArray.length > 1) {
                            let allTypeNames = [].concat(nameArray);
                            if (allTypeNames.length > 4) {
                                let truncCount = allTypeNames.length - 3;
                                allTypeNames.splice(3, truncCount, "...");
                            }
                            allTypeNames = allTypeNames.join("\n");
                            launchIcon[0].setAttribute(
                                "title",
                                `Go to \n${allTypeNames}\n${nameType}s`
                            );
                        } else {
                            launchIcon[0].setAttribute(
                                "title",
                                `Go to \n${nameArray[0]}\n${nameType}`
                            );
                        }
                    }
                };
                if (_.has(val, "@ref.instances") && !_.isEmpty(val["@ref"].instances)) {
                    let selectedRefs = _.get(val, "@ref.instances");
                    let selectedTypes = [];
                    selectedRefs.forEach((info) => {
                        selectedTypes.push(_refOptionIdMap[info.instanceId].instanceName);
                        setTooltip(selectedTypes, "instance");
                    });
                } else {
                    setTooltip($scope.types, "type");
                }
            } else {
                containingElem[0].classList.add("no_launch");
            }
            return true;
        };
        $scope.launchRef = () => {
            "use strict";

            let buildFilterString = (typesArray) => {
                let terms = typesArray.map((typeName) => `Type eq ${typeName}`);
                return terms.join(" or ");
            };

            let val = this.getValue();
            let launchObj = _.assign({}, $scope.refInfo);
            let selectedTypes = [];

            if (!_.isEmpty(val["@ref"].instances)) {
                launchObj.instanceIds = [];
                launchObj.instances = [];

                if (_.isArray(val["@ref"].instances)) {
                    val["@ref"].instances.forEach(function (v) {
                        launchObj.instanceIds.push(v.instanceId);
                        launchObj.instances.push({
                            instanceId: v.instanceId,
                            instanceName: _refOptionIdMap[v.instanceId].instanceName,
                        });
                        selectedTypes.push(v.type);
                    });
                    selectedTypes = _.uniq(selectedTypes);
                    if (selectedTypes.length > 1) {
                        launchObj.filter = buildFilterString(selectedTypes);
                    } else if (selectedTypes.length === 1) {
                        launchObj.type = selectedTypes[0];
                        launchObj.filter = "";
                    }
                }
            } else {
                if ($scope.types.length > 1) {
                    launchObj.filter = buildFilterString($scope.types);
                } else {
                    launchObj.type = $scope.types[0];
                    launchObj.filter = "";
                }
            }

            $scope.$emit("instance.launchRef", launchObj);
            $scope.$emit("RefLaunched", {
                launchObj: launchObj,
                configData: formCtrlDef.configData,
                configSettings: formCtrlDef.configSettings,
                refInstances: formCtrlDef.refInstances,
            });
        };

        //If there are instances
        if (formCtrlDef.refInstances) {
            $scope.types = [];
            if (formCtrlDef.configSettings.Ref.types) {
                formCtrlDef.configSettings.Ref.types.forEach(function (type) {
                    var refInstances = formCtrlDef.refInstances[type.typePath];
                    if (refInstances) {
                        $scope.refInfo = {
                            construct: type.construct,
                        };
                        $scope.types.push(_.get(type, "displayName", type.typeName));
                        refInstances.forEach(function (refInst) {
                            _refOptionIdMap[refInst.id] = {
                                instanceId: refInst.id,
                                construct: type.construct,
                                organizationId: refInst.organizationId,
                                subref: type.subref,
                                type: _.get(type, "displayName", type.typeName),
                                instanceName: refInst.instanceName,
                                labPath: refInst.labPath,
                                description: refInst.description,
                            };
                        });
                    }
                });
            }
        }

        //Setup Settings Object
        $scope.Array = {
            _itemsRegistry: _itemsRegistry,
            _defaultStringValue: _defaultStringValue,
            moveItemDown: function (itemId) {
                var item = _itemsRegistry[itemId];
                if (item) {
                    var index = _uiCheckboxItems.indexOf(item);
                    if (index !== -1 && index !== _uiCheckboxItems.length) {
                        var destIndex = index + 1;
                        _uiCheckboxItems.splice(destIndex, 0, _uiCheckboxItems.splice(index, 1)[0]);
                        //move Dom Elem
                        item.renderer.elem.insertAfter(item.renderer.elem.next());
                    }
                }
                _valueChangedListener();
            },
            moveItemUp: function (itemId) {
                var item = _itemsRegistry[itemId];
                if (item) {
                    var index = _uiCheckboxItems.indexOf(item);
                    if (index !== -1 && index !== 0) {
                        var destIndex = index - 1;
                        _uiCheckboxItems.splice(destIndex, 0, _uiCheckboxItems.splice(index, 1)[0]);
                        //move Dom Elem
                        item.renderer.elem.insertBefore(item.renderer.elem.prev());
                    }
                }
                _valueChangedListener();
            },
            checkAll: function () {
                _uiCheckboxItems.forEach(function (item) {
                    if (item.renderer) {
                        item.checkBox.setValue(true);
                    }
                });

                _valueChangedListener();
            },
            uncheckAll: function () {
                _uiCheckboxItems.forEach(function (item) {
                    if (item.renderer) {
                        item.checkBox.setValue(false);
                    }
                });

                _valueChangedListener();
            },
            /**
             * Append a new Ref Item to the end of the array
             * @param configData {ConfigurationData} The configData to populate this item with.
             */
            addRefItem: function (newValue, silent) {
                let configData = newValue;
                if (_.isUndefined(configData)) {
                    configData = {
                        name: _defaultStringValue,
                        value: _defaultStringValue,
                        label: _defaultStringValue,
                    };
                }
                var id = new Date().getTime();
                var item = {
                    id: id,
                    renderer: {
                        settings: {
                            instanceId: configData.instanceId,
                        },
                    },
                };
                let checkboxOptions = {
                    labelShown: true,
                    label: configData.label,
                    title: configData.title,
                };
                item.checkBox = new CheckBox(checkboxOptions);
                item.checkBox.on("Value", _valueChangedListener);
                item.checkBox.setValue(configData.value);

                _itemsRegistry[item.id] = item;
                _uiCheckboxItems.push(item);
                //Render
                let itemElem =
                    '<div class="array_item_renderer array_string_item_renderer array_checkbox">';
                itemElem += '<div class="ref_item_actions">';
                if (_showReorder) {
                    itemElem +=
                        '<i class="fa fa-arrow-up move_item_up" data-ng-click="Array.moveItemUp(\'' +
                        item.id +
                        "')\"></i>";
                    itemElem +=
                        '<i class="fa fa-arrow-down move_item_down" data-ng-click="Array.moveItemDown(\'' +
                        item.id +
                        "')\"></i>";
                }
                itemElem += "</div>";
                itemElem +=
                    '<launch-default-icon-gl data-icon = "form.launch" class="launch-ref-list" data-ng-click="Array.launchRef(\'' +
                    item.id +
                    '\')" title="Go to\n' +
                    configData.name +
                    '\ninstance"></launch-default-icon-gl>';

                itemElem += "</div>";

                var textFieldElem = $(itemElem);
                textFieldElem.append(item.checkBox.renderer.rootElement);

                // Create a link function by compiling the template
                var linkFn = $compile(textFieldElem);
                // Create the element with the compiled template with the same sc//ope
                var elem = linkFn($scope);
                // Append the element to the DOM
                refListContainerElem.addClass("ref-list-container");
                refListContainerElem.append(elem);

                item.renderer.elem = elem;

                if (!loadedDeferred.promise.isFulfilled()) {
                    var stringItemDeffered = q.defer();
                    addedItemPromises.push(stringItemDeffered.promise);
                    $timeout(function () {
                        stringItemDeffered.resolve();
                    });
                }
                $timeout(function () {
                    if (!silent) {
                        _valueChangedListener();
                    }
                });
            },
            closeItem: function (itemId, silent) {
                var item = _itemsRegistry[itemId];
                if (item) {
                    item.checkBox.shutdown();
                    delete _itemsRegistry[itemId];
                    var index = _uiCheckboxItems.indexOf(item);
                    if (index !== -1) {
                        _uiCheckboxItems.splice(index, 1);
                    }
                    item.renderer.elem.remove();
                }
                if (!silent) {
                    _valueChangedListener();
                }
            },
            launchRef: function (itemId) {
                "use strict";
                let item = _itemsRegistry[itemId];
                if (item) {
                    let instance = _refOptionIdMap[item.renderer.settings.instanceId];
                    if (instance) {
                        let launchObj = {
                            construct: instance.construct,
                            instanceIds: [instance.instanceId],
                            instances: [
                                {
                                    instanceId: instance.instanceId,
                                    instanceName: instance.instanceName,
                                },
                            ],
                            type: instance.type,
                        };
                        $scope.$emit("instance.launchRef", launchObj);
                        $scope.$emit("RefLaunched", {
                            launchObj: launchObj,
                            configData: formCtrlDef.configData,
                            configSettings: formCtrlDef.configSettings,
                            refInstances: formCtrlDef.refInstances,
                        });
                    }
                }
            },
        };

        //Setup directive
        var template = $templateCache.get(this.templateName);
        var choiceElem = $(template);
        let noInstanceElem;
        let arrayFooter;
        if (_.isEmpty(_refOptionIdMap)) {
            noInstanceElem = $("<label>No Available Instances</label>");
            noInstanceElem.addClass("ref-list-container");
        } else {
            let arrayFooterElem = '<div class="array_footer">';
            if (_showCheckAll) {
                arrayFooterElem +=
                    '<a class="array-checkbox-select-all array-footer-item" data-ng-click="Array.checkAll()">Check All</a>';
            }
            if (_showUnCheckAll) {
                arrayFooterElem +=
                    '<a class="array-checkbox-deselect-all array-footer-item" data-ng-click="Array.uncheckAll()">Uncheck All</a>';
            }
            arrayFooterElem += "</div>";
            arrayFooter = $(arrayFooterElem);
        }

        this._attachToParentElement(containingElem, choiceElem);

        var itemHeight = 43;
        var refContainer = self.arrayParentElem.find("> .array_nested_container > .ref-container");
        let refListContainerElem;
        if (noInstanceElem) {
            refContainer.append(noInstanceElem);
        } else {
            refListContainerElem = $("<div>");
            refContainer.append(refListContainerElem);
        }
        refContainer.append(
            '<launch-default-icon-gl data-icon="form.launch" class="launch-ref launch-all-ref" data-ng-click="launchRef()"></launch-default-icon-gl>'
        );
        if (arrayFooter) {
            refContainer.append(arrayFooter);
        }

        if (refListContainerElem && _minDisplayLines) {
            refListContainerElem.height(_minDisplayLines * itemHeight);
        }

        let stylesConfig = _.get(formCtrlDef, "configSettings.Display.styles", {});
        StyleUtil.renderStylesConfig(stylesConfig, containingElem[0]);

        // Apply item layout styles - these styles customize how this element is placed inside parent element
        let itemLayoutCssClass = _.get($scope, "jTypeContext.layout.item.cssClass", "");
        containingElem.addClass(itemLayoutCssClass);

        //Notify the world this adapter is ready to be compiled/linked and values retrieved
        self.emit("InitializationComplete", {
            initializedValue: self.getValue(),
        });

        self._errorsDiv = document.createElement("div");
        self._errorsDiv.classList.add("ref-errors");
        choiceElem.after(self._errorsDiv);
        return loadedDeferred.promise;
    };
    this.$init.$inject = ["$scope", "$templateCache", "$compile", "$timeout"];

    /**
     * This function allows derived objects to override this function.
     * @param containingElem
     * @param childElem
     * @private
     */
    this._attachToParentElement = function (containingElem, childElem) {
        containingElem.append(childElem);
        this.arrayParentElem = containingElem;
    };

    this.initializeCheckboxes = function (refKeys) {
        refKeys.forEach((refKey) => {
            let ref = _refOptionIdMap[refKey];
            let item = {
                value: false,
                name: ref.instanceName,
                label: ref.instanceName,
                instanceId: ref.instanceId,
                title: ref.description,
            };
            _scope.Array.addRefItem(item, true);
        });
    };

    /**
     * A Hook for when this control has been compiled/Linked.
     * @param $scope {$scope} The Angular Scope variable
     *
     * if $compiledAndLinked.$inject is specified those injection parameters will be used as the arguments
     */
    this.$compiledAndLinked = function ($scope, $timeout) {
        if (_.get(formCtrlDef, "configSettings.Display.readOnly")) {
            this._readOnlyField = true;
        }
        // Set up the checkboxes
        let refKeys = Object.keys(_refOptionIdMap);
        $scope.setRefLaunchTitle();
        if (formCtrlDef.configData) {
            //Update used/available based on configData
            self.setValue(formCtrlDef.configData);
            $timeout(function () {
                _setInitialReadOnlyState();
                loadedDeferred.resolve();
            });
        } else {
            _setInitialReadOnlyState();
            this.sortInstanceNames(refKeys);
            this.initializeCheckboxes(refKeys);
            $timeout(function () {
                _setInitialReadOnlyState();
                loadedDeferred.resolve();
            });
        }
    };
    this.$compiledAndLinked.$inject = ["$scope", "$timeout"];

    /********************************************************************************/
    /*** END Angular/Render Work                                                  ***/
    /********************************************************************************/
};
//Make this API inherit from EventEmitter
util.inherits(module.exports, EventEmitter);

//Tell the Form renderer that this is an Angular Control.
module.exports.isAngularControl = true;

//Tell the Form renderer that this adapter supports multi edit mode.
module.exports.isMultiEditSupported = true;
